/** 사용자 사이트(frontend) 도메인 — admin/.env `VITE_SERVICE_DOMAIN` */
export const SERVICE_DOMAIN =
  import.meta.env.VITE_SERVICE_DOMAIN ?? 'http://localhost:3000'
